import gql from "graphql-tag"

const fragment = gql`
  fragment userSavings on UserSaving {
    userSavings {
      header
      type
      value
    }
  }
`

export default fragment
